import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAoName, FormItemAoNo} from '../AO/FormChooseAo.jsx'
import {FormItemIeTitle} from '../IE/FormChooseIe.jsx'

export default function FormChooseIe(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemAoNo />
            <FormItemAoName />
            <FormItemIeTitle />
        </FormChooseExternal>
    )
}
